import { render, staticRenderFns } from "./MultiSelectList.vue?vue&type=template&id=2344d0f9&scoped=true"
import script from "./MultiSelectList.vue?vue&type=script&lang=js"
export * from "./MultiSelectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2344d0f9",
  null
  
)

export default component.exports